import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const NonSEButtons = (props) => {
	const { t, i18n } = useTranslation();

	const {formFields} = props;
	const {funnel_page, form_compoennts} = formFields;

	const pageData = useSelector(state => state.pageData);
	const {hook_status, preview} = pageData;

	const fv = useSelector(state => state.fv);

	const [indicator, setIndicator] = useState('off');
	
	const onClick = (e) => {
		e.preventDefault();

		const form = document.getElementById('reg-form');

		const $submitButton = $("#submit-btn");

		fv.validate().then(async function (status) {
			console.log(`validated: ${status}`);
			if (status == 'Valid') {
				setIndicator('on');

				var rc = await checkForm($submitButton, form);
				//console.log(`rc`, rc);

				if (!rc) {
					setIndicator('off');
				}
			}
		});
	}

	var tippyContent = '';
	switch (hook_status) {
		case 'warmup':
			tippyContent = t('活動即將開始');
			break;

		case 'expired':
			tippyContent = t('活動已結束');
			break;
	}

	return (
		<div className="button_area">
			<Tippy
				theme="primary"
				content={tippyContent}
				disabled={tippyContent === ''}
			>
				<span>
					<button
						type="submit"
						id="submit-btn"
						className={`btn btn-danger btn-md col-8 btn-lg ${hook_status !== 'live' ? 'disabled' : ''}`}
						disabled={hook_status !== 'live' || indicator === 'on' || preview}
						data-kt-indicator={indicator}
						onClick={onClick}
					>
						<span className="indicator-label">{funnel_page.cta_text}</span>
						<span className="indicator-progress">
							{t('請稍候...')}<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</span>
					</button>
				</span>
			</Tippy>
		</div>
	);
}

export default NonSEButtons;